import NavigationSidebar from './container'

export default NavigationSidebar



// WEBPACK FOOTER //
// ./src/legacy/containers/NavigationSidebar/index.js